import type { HomepageHeroClientProps } from "@/components/Homepage/HomepageHero/types";
import BaseHomepageHeroMarketplace from "../HomepageHeroMarketplace/BaseHomepageHeroMarketplace";
import BaseHomepageHeroCategory from "../HomepageHeroCategory/BaseHomepageHeroCategory";
import BaseHomepageHeroMerchandising from "../HomepageHeroMerchandising/BaseHomepageHeroMerchandising";
import BaseHomepageHeroSpotlight from "../HomepageHeroSpotlight/BaseHomepageHeroSpotlight";

export default function BaseHomepageHeroMix(props: HomepageHeroClientProps) {
  switch (props.variant) {
    case "merchandising":
      return <BaseHomepageHeroMerchandising {...props} />;
    case "marketplace":
      return <BaseHomepageHeroMarketplace {...props} />;
    case "category":
      return <BaseHomepageHeroCategory {...props} />;
    case "spotlight":
      return <BaseHomepageHeroSpotlight {...props} />;
    default:
      return <BaseHomepageHeroMarketplace />;
  }
}
